import EmptyState from "../store/emptyState";
import { MenuActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";

const menu = (state = EmptyState.menu, action) => {
  if (!state) {
    return {};
  }

  const { type, payload } = action;
  switch (type) {
    case MenuActionConstants.SELECT: {
      return { ...state, selectedItem: action.payload };
    }

    case MenuActionConstants.SET_SPORT_CATEGORIES: {
      return { ...state, sportCategories: action.payload };
    }

    case MenuActionConstants.SET_FAVOURITE_SPORTS: {
      return { ...state, favouriteSports: action.payload };
    }

    case MenuActionConstants.SET_FAVOURITE_SPORTS_SELECTABLE: {
      return { ...state, favouriteSportsSelectable: action.payload };
    }

    case MenuActionConstants.SET_FAVOURITE_SPORTS_RUNNING_INSIDE_INNER_MENU: {
      return {
        ...state,
        favouriteSportsRunningInsideInnerMenu: action.payload
      };
    }

    case MenuActionConstants.SET_HOME_SECTION_CATEGORIES: {
      return { ...state, homeSectionCategories: action.payload };
    }

    case MenuActionConstants.SET_LOYALTY_SECTION_CATEGORIES: {
      return { ...state, loyaltySectionCategories: action.payload };
    }

    case MenuActionConstants.DRAWERS_RENDERING: {
      return { ...state, drawersRendering: action.payload };
    }
    case MenuActionConstants.DRAWERS_LOADED: {
      return { ...state, drawersLoaded: action.payload };
    }

    case MenuActionConstants.SET_INNER_MENU_IGNORE_CLASS: {
      return { ...state, innerMenuIgnoreClass: payload };
    }

    case MenuActionConstants.SHOW_HAMBURGER_MENU: {
      return { ...state, hamburgerMenuVisible: true };
    }

    case MenuActionConstants.HIDE_HAMBURGER_MENU: {
      return { ...state, hamburgerMenuVisible: false };
    }

    case MenuActionConstants.SHOW_LANGUAGE_MENU: {
      return { ...state, languageMenuVisible: true };
    }

    case MenuActionConstants.HIDE_LANGUAGE_MENU: {
      return { ...state, languageMenuVisible: false };
    }

    case MenuActionConstants.SHOW_ODDS_MENU: {
      return { ...state, oddsMenuVisible: true };
    }

    case MenuActionConstants.HIDE_ODDS_MENU: {
      return { ...state, oddsMenuVisible: false };
    }

    case MenuActionConstants.SHOW_QUICK_LINKS_INNER_MENU: {
      return {
        ...state,
        quickLinksInnerMenuVisible: true,
        quickLinksInnerMenuItem: payload
      };
    }

    case MenuActionConstants.HIDE_QUICK_LINKS_INNER_MENU: {
      return {
        ...state,
        quickLinksInnerMenuVisible: false,
        quickLinksInnerMenuItem: undefined
      };
    }

    case MenuActionConstants.SHOW_APPEARANCE_MENU: {
      return { ...state, appearanceMenuVisible: true };
    }

    case MenuActionConstants.HIDE_APPEARANCE_MENU: {
      return { ...state, appearanceMenuVisible: false };
    }

    case MenuActionConstants.SET_NUMBER_OF_DISPLAYED_ITEMS: {
      return { ...state, numberOfDisplayedItems: payload };
    }

    case MenuActionConstants.SET_MENU_ITEMS: {
      return { ...state, menuItems: payload };
    }

    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.menu,
        EmptyState.menu
      );
  }
};

export default menu;
